<template>
	<v-container>
		<v-col class="px-0">
			<v-row>
				<v-col cols="12" class="text-right">
					<v-btn depressed color="primary" class="rounded-xl" @click="goPrint">
						<v-icon small color="white">mdi-printer</v-icon>
						<span class="pl-2">Print</span>
					</v-btn>
				</v-col>
			</v-row>
			<div class="mt-3">
				<v-row justify="center" id="section-to-print">
					<v-col cols="12" sm="12" md="8" xl="5">
						<v-card class="pa-3 elevation-0 rounded-xl hover-shadow mitra-card">
							<div class="mitra-card-item">
								<div class="d-flex justify-center">
									<div class="pa-1 yellow darken-1 rounded-pill">
										<v-img class="mitra-card-img rounded-pill" :src="userData.member_image_url ? userData.member_image_url : '/assets/image/profile-pict.png'"></v-img>
									</div>
								</div>
								<div class="pt-2 pt-sm-3 font-size-16 font-size-xs-11 yellow--text text--darken-1 font-weight-bold">{{ userData.member_network_code }}</div>
								<div class="pt-1 pt-sm-2 font-size-13 font-size-xs-9 yellow--text text--darken-1 font-weight-500">{{ userData.member_name }}</div>
								<div class="pt-1 font-size-11 font-size-xs-7 yellow--text text--darken-1 font-weight-500">Bergabung {{ userData.member_join_datetime | tanggal }}</div>
							</div>
						</v-card>
					</v-col>
					<v-col cols="12" sm="12" md="8" xl="5">
						<v-card class="pa-3 elevation-0 rounded-xl hover-shadow mitra-back-card">
							<div class="mitra-back-card-item">
								<div class="pt-1 pt-sm-3 font-size-10 font-size-xs-6 yellow--text text--darken-1 font-weight-500 d-flex">
									<div>1.</div>
									<div class="pl-2">Pemegang ID ini adalah Mitra/Customer PT. DSN</div>
								</div>
								<div class="pt-2 font-size-10 font-size-xs-6 yellow--text text--darken-1 font-weight-500 d-flex">
									<div>2.</div>
									<div class="pl-2">Apabila pemegang ID ini terlibat melanggar Hukum adalah Tanggung Jawab Pribadi</div>
								</div>
								<div class="pt-2 font-size-10 font-size-xs-6 yellow--text text--darken-1 font-weight-500 d-flex">
									<div>3.</div>
									<div class="pl-2">Masa Aktif ID ini selama Pemegang Aktif Menjadi Mitra PT. DSN</div>
								</div>
								<div class="pt-2 font-size-10 font-size-xs-6 yellow--text text--darken-1 font-weight-500 d-flex">
									<div>4.</div>
									<div class="pl-2">Bila menemukan ID mohon dikirim ke PT. DSN</div>
								</div>
								<div class="pt-2 pt-sm-4">
									<div class="pt-1 font-size-13 font-size-xs-7 yellow--text text--darken-1 font-weight-bold">Branch Office Madiun</div>
									<div class="pt-1 font-size-10 font-size-xs-6 yellow--text text--darken-1 font-weight-500">
										<div>Jl Kenangan Darogan - Munggut Wungu - Madiun -</div>
										<div>Jawa Timur INDONESIA 63182</div>
									</div>
								</div>
							</div>
						</v-card>
					</v-col>
				</v-row>
			</div>
		</v-col>
	</v-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
	components: {
	},
	data() {
		return {
			loading: false,
		}
	},
	computed: {
		...mapState('auth', ['userData']),
	},
	methods: {

		goPrint() {
			window.print()
		}
	},
	created() {
		this.$store.dispatch('setPageTitle', `Kartu Mitra Usaha`)
	}
};
</script>

<style type="text/css" scoped>

@media print {
	@page {
		size: a5;
	}
	#section-to-print .mitra-card {
		width: 100%;
	}
	#section-to-print .mitra-card .mitra-card-item {
		padding-left: 13rem;
	}
}

</style>